/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Faites glisser pour redimensionner le panneau',
  command_intelligence_close_aria: 'Fermer l’assistant',
  command_intelligence_send_aria: 'Envoyer le message',
  command_intelligence_stop_aria: 'Arrêter la réponse',
  command_intelligence_composer_input_aria: 'Message à Command Intelligence',
  command_intelligence_drawer_more_options: 'Plus d’options',
  command_intelligence_dock_position: 'Position d’ancrage',
  command_intelligence_dock_left: 'Gauche',
  command_intelligence_dock_right: 'Droite',
  command_intelligence_dock_top: 'Haut',
  command_intelligence_dock_bottom: 'Bas',
  command_intelligence_panel_layout: 'Disposition du panneau',
  command_intelligence_panel_layout_overlap: 'Superposer le contenu',
  command_intelligence_panel_layout_push: 'Pousser le contenu',
  command_intelligence_panel_auto_hide_overlap: 'Masquer automatiquement en cliquant à l’extérieur',
  command_intelligence_session_reset: 'Réinitialiser la conversation',
  command_intelligence_try_one_of_these: 'Essayez l’une de ces suggestions',
  command_intelligence_attach_hint: 'Joignez des éléments de contexte pour commencer à poser des questions.',
  command_intelligence_attach_modal_title: 'Joindre du contexte',
  command_intelligence_attach_modal_subtitle:
    'Choisissez parmi les éléments de cette vue. Les éléments déjà joints sont grisés.',
  command_intelligence_attach_modal_search_placeholder: 'Rechercher…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# élément disponible} other {# éléments disponibles}} · {selected} sélectionné(s)',
  command_intelligence_attach_modal_empty: 'Rien à joindre',
  command_intelligence_attach_modal_no_results: 'Aucun élément ne correspond à votre recherche',
  command_intelligence_context_bar_attached_section: 'Joint ({count})',
  command_intelligence_context_bar_clear_attached: 'Effacer',
  command_intelligence_context_bar_add: 'Joindre du contexte',
  command_intelligence_placeholder_ready: 'Posez une question…',
  command_intelligence_placeholder_attach: 'Joignez du contexte pour poser une question…',
  command_intelligence_composer_submit_hint: 'Entrée pour envoyer · Maj+Entrée pour une nouvelle ligne',
  command_intelligence_composer_stop_hint: 'Arrêter · rédigez votre prochain message en attendant',
  command_intelligence_response_stopped: 'Réponse arrêtée',
  command_intelligence_generation_in_progress: 'Traitement de votre question',
  command_intelligence_generation_trace_title: 'Étapes effectuées',
  command_intelligence_generation_trace_toggle: 'Afficher les étapes',
  command_intelligence_generation_trace_summary: '{completed} sur {total} étapes terminées',
  command_intelligence_generation_trace_summary_generic: 'Étapes de génération',
  command_intelligence_generation_tool_count: '{count, plural, one {# outil} other {# outils}}',
  command_intelligence_generation_turn_label: 'Tour {turn} sur {total}',
  command_intelligence_generation_turn_completed: 'Tour {turn} sur {total} terminé',
  command_intelligence_generation_turn_completed_elapsed: 'Tour {turn} sur {total} terminé ({seconds}s écoulées)',
  command_intelligence_generation_turn_completed_with_tools: 'Tour {turn} sur {total} terminé – {tools} utilisés',
  command_intelligence_generation_tools_used: '{tools} utilisés',
  command_intelligence_reasoning_thinking: 'Réflexion…',
  command_intelligence_reasoning_thought_for_seconds: 'Réflexion pendant {seconds} secondes',
  command_intelligence_reasoning_waiting: 'Traitement de votre question…',
  command_intelligence_attach_modal_done: 'Terminé',
  command_intelligence_attach_modal_attached_badge: 'joint',
  command_intelligence_attach_modal_attach: 'Joindre',
  command_intelligence_attach_modal_attach_count: 'Joindre ({count})',
  command_intelligence_attach_modal_close_aria: 'Fermer le sélecteur',
  command_intelligence_session_limit_context:
    'Limite de contexte atteinte. Réinitialisez la conversation pour continuer.',
  command_intelligence_session_limit_prompt:
    'Limite de messages atteinte. Réinitialisez la conversation pour continuer.',
  command_intelligence_suggested_followups: 'Suggestions de suivi',
  command_intelligence_credit_warning_line: '{pct}% des crédits IA mensuels de {scope} utilisés',
  command_intelligence_tooltip_prompts: '{count} sur {max} messages ({pct}%)',
  command_intelligence_tooltip_context: '{used} sur {max} jetons de contexte ({pct}%)',
  command_intelligence_tooltip_context_idle: 'L’utilisation du contexte apparaît après la première réponse',
  command_intelligence_credits_loading: 'Chargement des crédits…',
  command_intelligence_credits_unavailable: 'Crédits indisponibles',
  command_intelligence_credits_tooltip: 'Crédits IA mensuels pour {monthKey}',
  command_intelligence_credits_tooltip_short: 'Crédits IA mensuels',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Entité',
  command_intelligence_credits_used_of_cap: '{used} sur {cap} crédits',
  command_intelligence_credits_used_no_cap: '{used} crédits utilisés',
  command_intelligence_credits_monthly_title: 'Crédits IA mensuels',
  command_intelligence_compare_aria: 'Comparer les agents',
  command_intelligence_compare_tooltip: 'Exécuter la même question sur plusieurs profils d’agent',
  command_intelligence_compare_cancelled: 'Comparaison annulée',
  command_intelligence_compare_branch_failed: 'Branche de comparaison échouée',
  command_intelligence_compare_title: 'Comparaison d’agents',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} entrée / {outTok} sortie · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Bonne réponse',
  command_intelligence_feedback_bad_response: 'Mauvaise réponse',
  command_intelligence_feedback_dialog_title: 'Donner un avis',
  command_intelligence_feedback_dialog_body:
    'Aidez-nous à nous améliorer en donnant votre avis sur cette réponse. Votre avis sera envoyé à notre équipe opérationnelle.',
  command_intelligence_feedback_response_label: 'Réponse',
  command_intelligence_feedback_input_label: 'Votre avis (facultatif)',
  command_intelligence_feedback_input_placeholder: 'Qu’est-ce qui était incorrect ou peu utile dans cette réponse ?',
  command_intelligence_feedback_submit: 'Envoyer l’avis',
  command_intelligence_feedback_submit_error: 'Échec de l’envoi de l’avis. Veuillez réessayer.',
  command_intelligence_feedback_question_understanding: 'L’agent a-t-il compris ce que vous vouliez ?',
  command_intelligence_feedback_question_readability: 'La réponse était-elle facile à lire et à utiliser ?',
  command_intelligence_feedback_section_understanding: 'Compréhension',
  command_intelligence_feedback_section_readability: 'Lisibilité',
  command_intelligence_feedback_choice_none: 'Aucun',
  command_intelligence_feedback_choice_misunderstood_task: 'Tâche mal comprise',
  command_intelligence_feedback_choice_ignored_constraint: 'Contrainte ignorée',
  command_intelligence_feedback_choice_wrong_scope: 'Mauvaise portée',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Difficile à lire visuellement',
  command_intelligence_feedback_choice_wrote_too_much: 'Trop verbeux',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Explication peu fiable',
  command_intelligence_copy_aria: 'Copier dans le presse-papiers',
  command_intelligence_error_missing_invoke_permission:
    'Vous n’avez pas l’autorisation d’utiliser Command Intelligence pour cet agent. Demandez à votre administrateur d’accorder les autorisations Intelligence requises (par exemple, analyste).',
  command_intelligence_access_denied_title: 'Accès requis',
  command_intelligence_error_session_expired:
    'Votre session a expiré. Veuillez actualiser la page et vous reconnecter.',
};
